import React, { memo } from 'react';
import { formGroup, formControl, FormDataType, formArray } from '@core/utils/form';
import { CBody } from '@modules/common/CBody';
import { FormInput, FormCheckbox, FormColorPicker } from '@core/components/form';
import { WidgetConfirmProps } from '../types';
import { CardTitle, Col, Row } from 'reactstrap';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';

export function defineProgressCircleWidgetConfigForm() {
  return formGroup({
    color: formControl<string>({ label: 'Color' }),
  });
}

export type ProgressCircleWidgetConfigType = ReturnType<typeof defineProgressCircleWidgetConfigForm>;
export type ProgressCircleWidgetConfigData = FormDataType<typeof defineProgressCircleWidgetConfigForm>;

export const ProgressCircleWidgetConfig = memo((props: WidgetConfirmProps<ProgressCircleWidgetConfigType, ProgressCircleWidgetConfigData>) => {
  const { form, data } = props;
  const formValue = useNonNilObservable(form.value$);
  return (
    <CBody>
      <CardTitle>Widget Settings</CardTitle>
      <FormColorPicker control={form.controls.color} />
    </CBody>
  );
});
